export const convertPointsToList = (pts, yKey) => {
    let list = [];
    for (let i in pts) {
        list.push(pts[i].x);
        list.push(pts[i][yKey]);
    }
    return list;
};
